import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import parse from 'html-react-parser';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import graph from './graph.png';

const StyContent = styled(Box, {
    name: 'StyContent',
})(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    [theme.breakpoints.down('lg')]: {
        flexDirection: 'column',
    },
}));

const StyImageContainer = styled(Box, {
    name: 'StyImageContainer',
})(({ theme }) => ({
    margin: '2rem',
    width: '700px',
    minWidth: '600px',
    [theme.breakpoints.down('lg')]: {
        width: '100%',
        maxWidth: '600px',
        minWidth: '400px',
    },
}));

const StyTextArea = styled(Box, {
    name: 'StyTextArea',
})(({ theme }) => ({
    backgroundColor: theme.palette.lightGrey,
    height: 'fit-content',
    maxWidth: '500px',
    padding: '2rem',
    textAlign: 'justify',
    textJustify: 'inter-word',
}));

export default function MultiYearsComparison(): React.ReactElement {
    const { t } = useTranslation();

    return (
        <>
            <Typography variant="h5" sx={{ marginTop: '2rem' }}>
                {t('budgetOverview.ratioOverCurrentBudget')}
            </Typography>
            <StyContent>
                <StyImageContainer>
                    <img
                        src={graph}
                        alt={t('budgetOverview.ratioOverCurrentBudget')}
                        width="100%"
                    />
                </StyImageContainer>
                <StyTextArea>
                    <Typography variant="body1Bold">
                        {t('budgetOverview.textPart1Title')}
                    </Typography>
                    <p>{parse(t('budgetOverview.textPart1Text'))}</p>
                    <Typography variant="body1Bold">
                        {t('budgetOverview.textPart2Title')}
                    </Typography>
                    <p>{parse(t('budgetOverview.textPart2Text'))}</p>
                </StyTextArea>
            </StyContent>
        </>
    );
}
